import styled from 'styled-components';
import { motion, type Variants, type Transition } from 'framer-motion';

const Cert = styled(motion.div)`
  position: absolute;
  width: 59px;

  .nation {
    position: absolute;
    left: 8px;
    top: 0;
    transform: translateY(-50%);
  }

  .cert-image {
    border-radius: 4px;
    overflow: hidden;
  }
`;

export const CertId = styled(Cert)`
  z-index: 4;
  box-shadow: 0px 7.63px 10.17px 0px #3042780f, 0px 5.08px 7.63px 0px #3042780f,
    0px 1.27px 2.54px 0px #3042780f;
`;

export const CertUs = styled(Cert)`
  z-index: 5;
  box-shadow: 0px 7.28px 9.7px 0px #3042780f, 0px 4.85px 7.28px 0px #3042780f,
    0px 1.21px 2.43px 0px #3042780f;
`;

export const CertVn = styled(Cert)`
  z-index: 6;
  box-shadow: 0px -2.52px 10.09px 0px #3295460d, 0px -1.89px 7.57px 0px #3295460d,
    0px -0.63px 3.15px 0px #3295460d;
`;

const certTransition: Transition = {
  duration: 0.3,
  ease: 'easeOut',
};

export const certWrapperVariants: Variants = {
  hidden: {
    transition: {
      staggerChildren: 0.075,
    },
  },
  visible: {
    transition: {
      staggerChildren: 0.075,
    },
  },
};
export const certIdVariants: Variants = {
  hidden: {
    left: 76,
    bottom: -6,
    x: '-50%',
    rotateZ: -15.56,
    transition: certTransition,
  },
  visible: {
    left: 62,
    bottom: 15,
    x: '-50%',
    rotateZ: -30.68,
    transition: certTransition,
  },
};

export const certUsVariants: Variants = {
  hidden: {
    left: 84,
    bottom: -15,
    x: '-50%',
    rotateZ: -6.85,
    transition: certTransition,
  },
  visible: {
    left: 77,
    bottom: 19,
    x: '-50%',
    rotateZ: -11.56,
    transition: certTransition,
  },
};

export const certVnVariants: Variants = {
  hidden: {
    left: 94,
    bottom: -7,
    x: '-50%',
    rotateZ: 5.55,
    transition: certTransition,
  },
  visible: {
    left: 96,
    bottom: 25,
    x: '-50%',
    rotateZ: 5.55,
    transition: certTransition,
  },
};
